import { NgModule } from '@angular/core';
import {
  CommonModule,
  DatePipe,
  PercentPipe,
  DecimalPipe,
} from '@angular/common';
import { AggridHelperService } from './aggrid-helper.service';
import { CommonToolService } from './common-tool.service';

@NgModule({
  declarations: [],
  providers: [
    AggridHelperService,
    CommonToolService,
    DatePipe,
    PercentPipe,
    DecimalPipe,
  ],
  imports: [CommonModule],
  exports: [],
})
export class CommonServiceModule {}
